<template>
  <Tabbar v-model="active" :safe-area-inset-bottom="true" active-color="#00b852" style="z-index: 20;" @change="changeTab">
    <TabbarItem name="home">
      <span>{{ $t('tab_workbench') }}</span>
      <template #icon="{ active }">
        <van-icon :name="active ? 'wap-home' : 'wap-home-o'" />
      </template>
    </TabbarItem>
    <TabbarItem name="hcp">
      <span>{{ $t('tab_customer') }}</span>
      <template #icon="{ active }">
        <van-icon :name="active ? 'friends' : 'friends-o'" />
      </template>
    </TabbarItem>
    <TabbarItem v-if="showAIAssistant" name="ai" class="ai-tab-item">
      <template #icon="{ active }">
        <div class="ai-icon-wrapper">
          <font-awesome-icon :icon="[active ? 'fas' : 'far', 'lightbulb']" class="ai-icon" />
        </div>
      </template>
      <span>{{ $t('ai_assistant') }}</span>
    </TabbarItem>
    <TabbarItem name="visit" :badge="visitDraftCount || ''">
      <span>{{ $t('tab_visit') }}</span>
      <template #icon="{ active }">
        <van-icon :name="active ? 'chat' : 'chat-o'" />
      </template>
    </TabbarItem>
    <TabbarItem name="task" :badge="taskCount || ''">
      <span>{{ $t('tab_task') }}</span>
      <template #icon="{ active }">
        <van-icon :name="active ? 'clock' : 'clock-o'" />
      </template>
    </TabbarItem>
    <!-- <TabbarItem name="content" icon="list-switch">内容</TabbarItem> -->
  </Tabbar>
</template>

<script>
import {Tabbar, TabbarItem, Toast, Icon} from 'vant';
import {getLocalStorage, isEnableAI} from '@/utils/index';
import { getMyCampaignEventStat } from '@/api/nba';
import {listVisitDrafts} from '@/utils/visitDraft';

export default {
  name: 'GBATabBar',
  components: {
    Tabbar,
    TabbarItem,
    vanIcon: Icon,
  },
  data() {
    return {
      active: 'home',
      taskCount: 0,
      visitDraftCount: 0,
      showAIAssistant: isEnableAI(),
    };
  },
  created() {
    this.updateActiveTab(this.$route.name);
    this.showAIAssistant = isEnableAI();

    this.$router.afterEach((to) => {
      this.updateActiveTab(to.name);
    });

    if (this.$route.name !== 'gbaOverview') {
      this.getTaskCount();
    }
    this.getVisitDraftCount();
    this.$root.$on('updateTaskCount', this.handleTaskCountUpdate);
    this.$root.$on('updateVisitDraftCount', this.getVisitDraftCount);
  },
  beforeDestroy() {
    this.$root.$off('updateTaskCount', this.handleTaskCountUpdate);
    this.$root.$off('updateVisitDraftCount', this.getVisitDraftCount);
  },
  methods: {
    handleTaskCountUpdate(count) {
      if (typeof count === 'number') {
        this.taskCount = count;
        return;
      }

      this.getTaskCount();
    },
    async getTaskCount() {
      try {
        const res = await getMyCampaignEventStat();
        this.taskCount = res && res.data ? res.data.unexecuted_task_count || 0 : 0;
      } catch (error) {
        console.error('Failed to get task count:', error);
        this.taskCount = 0;
      }
    },
    getVisitDraftCount() {
      this.visitDraftCount = listVisitDrafts({
        userId: getLocalStorage('user_id'),
        mode: 'gba',
      }).length;
    },
    updateActiveTab(routeName) {
      switch (routeName) {
        case 'gbaOverview':
          this.active = 'home';
          break;
        case 'gbaDoctorList':
        case 'gbaDoctorDetail':
          this.active = 'hcp';
          break;
        case 'gbaVisitList':
          this.active = 'visit';
          break;
        case 'gbaContent':
          this.active = 'content';
          break;
        case 'gbaTask':
        case 'gbaTaskSummaryDetail':
          this.active = 'task';
          break;
        default:
          if (routeName.startsWith('gba')) {
            // maybe keep current active?
          }
          break;
      }
    },
    changeTab(e) {
      switch (e) {
        case 'home':
          this.$router.push({ path: '/gba/overview' });
          break;
        case 'hcp':
          this.$router.push({ path: '/gba/list' });
          break;
        case 'ai':
          this.$root.$emit('open-ai-chat');
          // Reset selection to match current route so it doesn't look like we navigated away
          this.$nextTick(() => {
            this.updateActiveTab(this.$route.name);
          });
          break;
        case 'visit':
          this.$router.push({ path: '/gba/visit-list' });
          break;
        case 'content':
          this.$router.push({ path: '/gba/content' });
          break;
        case 'task':
          this.$router.push({ path: '/gba/task' });
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .van-tabbar__item--active {
    color: #00b852;
  }
  .van-info {
    background-color: #00b852;
    font-size: 9px;
  }

  .van-tabbar-item__text {
    font-size: 10px;
  }

  .ai-tab-item {
    .van-tabbar-item__text {
      font-size: 9px;
      transform-origin: center top;
      margin-top: -10px;
      display: inline-block;
    }

    .van-tabbar-item__icon {
      margin-bottom: 0;
      height: 48px; // Reserve space
    }

    .ai-icon-wrapper {
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translateX(-50%);
      width: 48px;
      height: 48px;
      border-radius: 50%;
      background: linear-gradient(135deg, #006b4f, #008f72, #00b852);
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
      border: 4px solid #fff;
      z-index: 10;

      .ai-icon {
        color: white;
        font-size: 20px;
      }
    }
  }
}
</style>
